import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { SERVICES } from "@/lib/content";

export default function ServicesGrid({ heading = true }) {
  return (
    <section data-testid="services-grid-section" className="section-pad bg-bone">
      <div className="container-narrow">
        {heading && (
          <div className="mb-16 grid grid-cols-1 gap-10 md:grid-cols-12">
            <div className="md:col-span-5">
              <span className="eyebrow">Practice Areas</span>
              <h2 className="mt-4 text-4xl font-bold leading-tight text-ink md:text-5xl lg:text-[56px]">
                Focused expertise, three practice areas.
              </h2>
            </div>
            <p className="text-base leading-relaxed text-ink-soft md:col-span-6 md:col-start-7 md:text-lg">
              We have deliberately chosen to do a few things exceptionally well.
            </p>
          </div>
        )}

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
            >
              <Link
                to={`/services/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="group block h-full"
              >
                <div className="relative aspect-[4/5] overflow-hidden bg-sage-50">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink/40 via-transparent to-transparent" />
                  <div className="absolute right-4 top-4 grid h-10 w-10 place-items-center border border-white/40 bg-white/10 text-white backdrop-blur-md transition-all group-hover:bg-white group-hover:text-sage-700">
                    <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
                  </div>
                </div>
                <div className="pt-6">
                  <h3 className="text-2xl font-bold text-ink transition-colors group-hover:text-sage-700 md:text-[26px]">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-ink-soft">
                    {s.short}
                  </p>
                  <span className="mt-5 inline-block text-[11px] font-medium uppercase tracking-[0.22em] text-sage-600">
                    Explore →
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
